<template>
  <div id="rg-portfolio">
    <div class="vx-row items-stretch">
      <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mb-base">
        <vx-card class="h-full">
          <vs-list>
            <vs-list-header title="Resumen del portafolio"></vs-list-header>
            <vs-list-item title="Saldo disponible">{{ explicitMoneyFormat(finalBalance) }}</vs-list-item>
            <vs-list-item title="Compromiso de inversión">{{ explicitMoneyFormat(investmentCommitment) }}</vs-list-item>
            <vs-list-item title="Inversión efectiva">{{ explicitMoneyFormat(fixedInvestment) }}</vs-list-item>
            <vs-list-item title="Total">
              <p class="bold text-lg">{{ explicitMoneyFormat(briefcase) }}</p>
            </vs-list-item>
          </vs-list>
        </vx-card>
      </div>
      <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mb-base">
        <vx-card class="flex flex-col justify-center items-center h-full">
          <div class="text-center">
            <h1>{{ explicitMoneyFormat(briefcase) }}</h1>
            <p class="mt-5 h5-normal">Valor de la cuenta</p>
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mb-base">
        <vx-card class="flex flex-col justify-center items-center h-full">
          <div class="text-center">
            <h1 class="mt-5">{{ explicitMoneyFormat(lastMonthPortfolio.period_generated_returns) }}</h1>
            <p class="h5-normal mt-5 mb-4">Rendimientos generados después de impuestos y comisiones.</p>
            <label>Periodo: <b>{{ lastMonthPeriodFormat }}</b></label>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col xl:w-1/3 w-full mb-base">
        <vx-card :title="'Resumen de la inversión en el periodo'" style="height: 100%;">
          <label>Periodo: <b>{{ lastMonthPeriodFormat }}</b></label>
          <!-- <vs-button color="primary" icon-pack="feather" size="small" type="border" class="px-3 mt-4"
            icon="icon-download" @click="downloadCSV">Descargar datos</vs-button> -->
          <vs-list class="mt-1">
            <vs-list-item title="Inversión inicial">{{
              explicitMoneyFormat(lastMonthPortfolio.initial_investment_balance) }}</vs-list-item>
            <vs-list-item title="+ Inversiones">{{ explicitMoneyFormat(lastMonthPortfolio.investments) }}</vs-list-item>
            <vs-list-item title="- Reembolso de inversión">{{
              explicitMoneyFormat(lastMonthPortfolio.investment_refunds)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.shares_amount_bought != 0" title="+ Compra de participación">{{
              explicitMoneyFormat(lastMonthPortfolio.shares_amount_bought) }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.shares_amount_sold != 0" title="+ Venta de participación">{{
              explicitMoneyFormat(lastMonthPortfolio.shares_amount_sold)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.shares_amount_transfer_received != 0"
              title="+ Recepción de participación">{{
                explicitMoneyFormat(lastMonthPortfolio.shares_amount_transfer_received) }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.shares_amount_transfer_sent != 0" title="- Envío de participación">{{
              explicitMoneyFormat(lastMonthPortfolio.shares_amount_transfer_sent) }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.market_shares_amount_bought != 0"
              title="+ Compra de participación">{{
                explicitMoneyFormat(lastMonthPortfolio.market_shares_amount_bought) }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.market_shares_amount_sold != 0" title="- Venta de participación">{{
              explicitMoneyFormat(lastMonthPortfolio.market_shares_amount_sold) }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.market_shares_amount_transfer_received != 0"
              title="+ Recepción de participación">{{
                explicitMoneyFormat(lastMonthPortfolio.market_shares_amount_transfer_received) }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.market_shares_amount_transfer_sent != 0"
              title="- Envío de participación">{{
                explicitMoneyFormat(lastMonthPortfolio.market_shares_amount_transfer_sent) }}</vs-list-item>
            <vs-list-item title="- Amortizaciones">{{
              explicitMoneyFormat(lastMonthPortfolio.amortizations) }}</vs-list-item>
            <vs-list-item title="- Quebrantos">{{
              explicitMoneyFormat(lastMonthPortfolio.loan_loss_provision) }}</vs-list-item>
            <vs-list-item title="+ Reestructuras">{{
              explicitMoneyFormat(lastMonthPortfolio.restructured_loans) }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.investment_adjustments != 0" title="+ Ajuste a la inversión">{{
              explicitMoneyFormat(lastMonthPortfolio.investment_adjustments) }}</vs-list-item>
            <vs-list-item title="= Inversión final">
              <p class="bold text-lg">{{ explicitMoneyFormat(lastMonthPortfolio.final_investment_balance) }}</p>
            </vs-list-item>
          </vs-list>
        </vx-card>
      </div>

      <div class="vx-col xl:w-2/3 w-full">
        <vx-card class="mb-5 text-white" card-background="dark">
          <div class="vx-row">
            <div class="vx-col w-full">
              <p class="bold text-2xl" style="color: white; margin-bottom: 0 !important;">Resumen de inversiones.</p>
            </div>
          </div>
        </vx-card>
        <vx-card class="mb-base" v-if="!isSmallerScreen">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <p class="card-sub-title">Cuenta en el tiempo</p>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vue-apex-charts type="line" height="250" :options="chartOptions" :series="series"></vue-apex-charts>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col xl:w-1/3 w-full mb-base">
        <vx-card :title="'Resumen del saldo en el periodo'" style="height: 100%;">
          <label>Periodo: <b>{{ lastMonthPeriodFormat }}</b></label>
          <vs-list class="mt-1">
            <!-- saldo inicial -->
            <vs-list-item title="Saldo inicial">{{
              explicitMoneyFormat(lastMonthPortfolio.initial_balance) }}</vs-list-item>
            <!-- abonos -->
            <vs-list-header v-if="lastMonthPortfolio.deposits != 0" color="success" title="Abonos" />
            <vs-list-item title="+ Transferencia nacional">{{ explicitMoneyFormat(lastMonthPortfolio.national_transfers)
              }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.international_transfers != 0"
              title="+ Transferencia internacional">{{
                explicitMoneyFormat(lastMonthPortfolio.international_transfers)
              }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.direct_debit != 0" title="+ Domiciliaciones">{{
              explicitMoneyFormat(lastMonthPortfolio.direct_debit)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.positive_balance_adjustment != 0" title="+ Ajuste de saldo">{{
              explicitMoneyFormat(lastMonthPortfolio.positive_balance_adjustment)
            }}</vs-list-item>
            <!-- pagos recibidos -->
            <vs-list-header v-if="lastMonthPortfolio.payments_received != 0" color="success" title="Pagos recibidos" />
            <vs-list-item v-if="lastMonthPortfolio.amortizations != 0" title="+ Amortizaciones">{{
              explicitMoneyFormat(lastMonthPortfolio.amortizations)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.interest != 0" title="+ Intereses">{{
              explicitMoneyFormat(lastMonthPortfolio.interest)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.interest_tax != 0" title="+ IVA de Intereses">{{
              explicitMoneyFormat(lastMonthPortfolio.interest_tax)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.tax_exempt_interest != 0" title="+ Intereses exentos de IVA">{{
              explicitMoneyFormat(lastMonthPortfolio.tax_exempt_interest)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.bonus != 0" title="+ Bonificaciones">{{
              explicitMoneyFormat(lastMonthPortfolio.bonus)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.bonus_tax != 0" title="+ IVA Bonificaciones">{{
              explicitMoneyFormat(lastMonthPortfolio.bonus_tax)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.recovery_costs != 0" title="- Gastos de recuperación">{{
              explicitMoneyFormat(lastMonthPortfolio.recovery_costs)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.recovery_costs_tax != 0" title="- IVA Gastos de recuperación">{{
              explicitMoneyFormat(lastMonthPortfolio.recovery_costs_tax)
            }}</vs-list-item>
            <!-- comisiones cobradas -->
            <vs-list-header v-if="lastMonthPortfolio.institutional_investor_bonus != 0" color="success"
              title="Comisiones cobradas" />
            <vs-list-item v-if="lastMonthPortfolio.institutional_investor_liquidity_bonus != 0"
              title="+ Por liquidez">{{
                explicitMoneyFormat(lastMonthPortfolio.institutional_investor_liquidity_bonus)
              }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.institutional_investor_liquidity_bonus_fee != 0"
              title="+ IVA por liquidez">{{
                explicitMoneyFormat(lastMonthPortfolio.institutional_investor_liquidity_bonus_fee)
              }}</vs-list-item>
            <!-- retiros -->
            <vs-list-header v-if="lastMonthPortfolio.withdraws != 0" color="success" title="Retiros" />
            <vs-list-item v-if="lastMonthPortfolio.national_withdraws != 0" title="- Transferencia nacional">{{
              explicitMoneyFormat(lastMonthPortfolio.national_withdraws)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.international_withdraws != 0"
              title="- Transferencia internacional">{{
                explicitMoneyFormat(lastMonthPortfolio.international_withdraws)
              }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.cancelled_withdraws != 0" title="+ Reembolso de retiro">{{
              explicitMoneyFormat(lastMonthPortfolio.cancelled_withdraws)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.negative_balance_adjustment != 0" title="- Ajuste de saldo">{{
              explicitMoneyFormat(lastMonthPortfolio.negative_balance_adjustment)
            }}</vs-list-item>
            <!-- inversiones -->
            <vs-list-header v-if="lastMonthPortfolio.full_investments != 0" color="success" title="Inversiones" />
            <vs-list-item v-if="lastMonthPortfolio.investments != 0" title="- Inversiones">{{
              explicitMoneyFormat(lastMonthPortfolio.investments)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.investment_refunds != 0" title="+ Reembolso de inversión">{{
              explicitMoneyFormat(lastMonthPortfolio.investment_refunds)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.shares_amount_bought != 0" title="- Compra de participación (MP)">{{
              explicitMoneyFormat(lastMonthPortfolio.shares_amount_bought)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.shares_amount_sold != 0" title="+ Venta de participación (MP)">{{
              explicitMoneyFormat(lastMonthPortfolio.shares_amount_sold)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.market_shares_amount_bought != 0"
              title="- Compra de participación (MS)">{{
                explicitMoneyFormat(lastMonthPortfolio.market_shares_amount_bought)
              }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.market_shares_amount_sold != 0"
              title="+ Venta de participación (MS)">{{
                explicitMoneyFormat(lastMonthPortfolio.market_shares_amount_sold)
              }}</vs-list-item>
            <!-- retenciones -->
            <vs-list-header v-if="lastMonthPortfolio.withholdings != 0" color="success" title="Retenciones" />
            <vs-list-item v-if="lastMonthPortfolio.isr_withholding != 0" title="- ISR intereses">{{
              explicitMoneyFormat(lastMonthPortfolio.isr_withholding)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.iva_withholding != 0" title="- IVA intereses">{{
              explicitMoneyFormat(lastMonthPortfolio.iva_withholding)
            }}</vs-list-item>
            <!-- comisiones -->
            <vs-list-header v-if="lastMonthPortfolio.fees != 0" color="success" title="Comisiones" />
            <vs-list-item v-if="lastMonthPortfolio.success_fee != 0" title="- Por éxito">{{
              explicitMoneyFormat(lastMonthPortfolio.success_fee)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.success_fee_tax != 0" title="- IVA por éxito">{{
              explicitMoneyFormat(lastMonthPortfolio.success_fee_tax)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.administration_fee != 0" title="- Por procesamiento">{{
              explicitMoneyFormat(lastMonthPortfolio.administration_fee)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.administration_fee_tax != 0" title="- IVA por procesamiento">{{
              explicitMoneyFormat(lastMonthPortfolio.administration_fee_tax)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.rejected_claim_fee != 0" title="- Por aclaración improcedente">{{
              explicitMoneyFormat(lastMonthPortfolio.rejected_claim_fee)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.rejected_claim_fee_tax != 0"
              title="- IVA por aclaración improcedente">{{
                explicitMoneyFormat(lastMonthPortfolio.rejected_claim_fee_tax)
              }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.returned_payment_fee != 0" title="- Por rechazo de cargos">{{
              explicitMoneyFormat(lastMonthPortfolio.returned_payment_fee)
            }}</vs-list-item>
            <vs-list-item v-if="lastMonthPortfolio.returned_payment_fee_tax != 0" title="- IVA por rechazo de cargos">{{
              explicitMoneyFormat(lastMonthPortfolio.returned_payment_fee_tax)
            }}</vs-list-item>
            <!-- saldo final -->
            <vs-list-item title="= Saldo final">
              <p class="bold text-lg">{{ explicitMoneyFormat(lastMonthPortfolio.final_balance) }}</p>
            </vs-list-item>
          </vs-list>
        </vx-card>
      </div>
      <!-- <div class="vx-col xl:w-1/3 lg:w-1/2 md:w-full w-full mt-5">
        <vx-card title="Por calificación.">
          <vue-apex-charts type="donut" :options="qualificationsChartOptions" :series="qualificationsSeries"
            v-if="!ignoreQualificationsDonut"></vue-apex-charts>
          <vs-list>
            <vs-list-item v-for="(item, index) in qualificationsLegendData" :title="item.k">{{ item.v
            }}&emsp;&emsp;&emsp;&emsp;{{ item.p }}</vs-list-item>
          </vs-list>
          <div class="vx-row" v-if="ignoreQualificationsDonut">
            <div class="vx-col w-full">
              <h5 class="opacity-50">Aún no has invertido en ningún proyecto dentro de la Red.</h5>
            </div>
          </div>
        </vx-card>
      </div> -->
      <div class="vx-col xl:w-2/3 w-full">
        <vx-card title="Estatus de la cartera." class="mb-base" >
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <vue-apex-charts type="donut" height="300" :options="cstatusesChartOptions" :series="creditStatusesSeries"
                v-if="!ignoreSunflowersDonut"></vue-apex-charts>
            </div>
            <div class="vx-col lg:w-1/2 w-full flex items-center">
              <vs-list>
                <vs-list-item v-for="(item, index) in creditStatusesLegendData" :title="item.k">{{ item.v
                }}&emsp;&emsp;&emsp;&emsp;{{ item.p }}</vs-list-item>
              </vs-list>
            </div>
          </div>
          <div class="vx-row" v-if="ignoreSunflowersDonut">
            <div class="vx-col w-full">
              <h5 class="opacity-50">Aún no has invertido en ningún proyecto dentro de la Red.</h5>
            </div>
          </div>
        </vx-card>
        <vx-card title="Cartera por calificación.">
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <vue-apex-charts type="donut" height="300" :options="qualificationsChartOptions" :series="qualificationsSeries"
                v-if="!ignoreQualificationsDonut"></vue-apex-charts>
            </div>
            <div class="vx-col lg:w-1/2 w-full flex items-center">
              <vs-list>
                <vs-list-item v-for="(item, index) in qualificationsLegendData" :title="item.k">{{ item.v
                  }}&emsp;&emsp;&emsp;&emsp;{{ item.p }}</vs-list-item>
              </vs-list>
            </div>
          </div>
          <div class="vx-row" v-if="ignoreQualificationsDonut">
            <div class="vx-col w-full">
              <h5 class="opacity-50">Aún no has invertido en ningún proyecto dentro de la Red.</h5>
            </div>
          </div>
        </vx-card>
      </div>
      <!-- <div class="vx-col xl:w-1/3 lg:w-1/2 md:w-full w-full mt-5">
        <vx-card title="Información adicional.">
          <vs-list>
            <vs-list-item v-for="(item, index) in extraData" :title="item.status_str + ' ' + countFormat(item.total)">{{
              item.amount }}</vs-list-item>
          </vs-list>
        </vx-card>
      </div> -->
    </div>
  </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper";
import dateHelper from "@mixins/dateHelper";
import qualificationsHelper from "@mixins/qualificationsHelper";
import projectStatusesHelper from "@mixins/projectStatusesHelper";
import creditStatusesHelper from "@mixins/creditStatusesHelper";
import VueApexCharts from 'vue-apexcharts';
const periodOptions = [
  { label: "Histórico", value: null },
  { label: "24 meses", value: "24" },
  { label: "12 meses", value: "12" },
];
export default {
  mixins: [formatHelper, dateHelper, qualificationsHelper, projectStatusesHelper, creditStatusesHelper],
  components: { VueApexCharts },
  props: {
    InvestorId: {
      type: [String,Number],
      required: true
    }
  },
  data() {
    return {
      lastMonthPortfolio: {},
      accountTotalMonths: 12,
      periodAccountOptions: periodOptions,
      currentFixedInvestmentProjects: [],
      extraData: [],
      isFirstTime: true,
      isMounted: false,
      briefcase: 0,
      fixedInvestment: 0,
      investmentCommitment: 0,
      finalBalance: 0,
      series: [{
        name: "",
        data: []
      }],
      chartOptions: {
        chart: {
          zoom: {
            enabled: true
          },
          toolbar: {
            tools: {
              download: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
            autoSelected: 'none'
          },
          locales: [{
            "name": "en",
            "options": {
              "toolbar": {
                "exportToPNG": "Descargar PNG",
                "exportToCSV": "Descargar CSV",
                "selectionZoom": "Zoom en área",
                "zoomIn": "Acercar",
                "zoomOut": "Alejar",
                "pan": "Paneo",
                "reset": "Reestablecer"
              }
            }
          }],
          defaultLocale: "en"
        },
        colors: ['#28DE18'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: '',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
        },
        yaxis: {
          labels: {
            formatter: (value) => { return this.explicitMoneyFormat(value, 0) },
          }
        },
        noData: {
          text: 'Cargando...'
        }
      },
      qualificationsChartOptions: {
        colors: ['#28DE18'],
        dataLabels: { enabled: false },
        donut: { labels: { show: false } },
        legend: { show: false },
        tooltip: { y: { formatter: (value) => { return this.explicitMoneyFormat(value, 0) } } },
        labels: [],
      },
      pstatusesChartOptions: {
        colors: ['#28DE18'],
        dataLabels: { enabled: false },
        donut: { labels: { show: false } },
        legend: { show: false },
        tooltip: { y: { formatter: (value) => { return this.explicitMoneyFormat(value, 0) } } },
        labels: [],
      },
      cstatusesChartOptions: {
        colors: ['#28DE18'],
        dataLabels: { enabled: false },
        donut: { labels: { show: false } },
        legend: { show: false },
        tooltip: { y: { formatter: (value) => { return this.explicitMoneyFormat(value, 0) } } },
        labels: [],
      },
      qualificationsSeries: [],
      projectStatutesSeries: [],
      creditStatusesSeries: [],
      projectsPortfolioInfo: null,

      qualificationsLegendData: [],
      projectStatusesLegendData: [],
      creditStatusesLegendData: [],

      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      shortMonthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'],

      ignoreQualificationsDonut: false,
      ignoreSunflowersDonut: false,
    }
  },
  async mounted() {
    this.isMounted = false
    this.showLoading(true)
    await this.getPortfolio();
    await this.getProjectsPortfolio();
    this.isMounted = true
    this.showLoading(false)
  },
  watch: {
    accountTotalMonths: async function (old, newval) {
      if (old !== newval) {
        this.showLoading(true)
        await this.getPortfolio();
      }
    }
  },
  computed: {
    lastMonthPeriodFormat() {
      if (!this.lastMonthPortfolio.balance_date) {
        return "--";
      }
      const date = new Date(this.lastMonthPortfolio.balance_date);
      const start = new Date(date.getFullYear(), date.getMonth(), 1);
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return "del " + this.humanizedCompactDate(start) + " al " + this.humanizedCompactDate(end);
    },
    isLgOrSmallerScreen() {
      return this.$store.state.windowWidth <= 1200;
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth <= 576;
    },
  },
  methods: {
    countFormat(total) {
      return total != null ? '(' + total + ')' : '';
    },
    monthName(index) {
      return this.monthNames[index - 1];
    },
    shortMonthName(index) {
      return this.shortMonthNames[index - 1];
    },
    async getPortfolio() {
      this.showLoading(true)
      try {
        const res = await axios.post(`/api/v2/investor/${this.InvestorId}/getPortfolioNew`, { account_total_months: this.accountTotalMonths });
        const briefInfo = res.data
        this.fixedInvestment = briefInfo.currentPortfolio.fixed_investment;
        this.investmentCommitment = briefInfo.currentPortfolio.investment_commitment;
        this.finalBalance = briefInfo.currentPortfolio.final_balance;
        this.briefcase = briefInfo.currentPortfolio.total;
        this.lastMonthPortfolio = briefInfo.lastMonthPortfolio || {};

        let seriesData = [];
        let seriesLabels = [];
        briefInfo.portfoliosAcrossTime.forEach(f => {
          seriesData.push(f.portfolio);
          if (!this.accountTotalMonths) {
            seriesLabels.push(`${f.year}`);
          } else {
            seriesLabels.push(`${this.shortMonthName(f.month)} ${f.year}`);
          }
        });

        this.series = [{
          name: "",
          data: seriesData
        }];

        this.chartOptions = {
          xaxis: {
            categories: seriesLabels
          }
        };
        // se genera log de accion
        if (this.isFirstTime) {
          this.saveInvestorLogAction("LC9-16");
          this.isFirstTime = false;
        }
      }
      catch (e) {
      }
      this.showLoading(false)
    },
    async getProjectsPortfolio() {
      try {
        const res = await axios.get(`/api/v2/investor/${this.InvestorId}/getProjectsPortfolioNew`);
        const ppi = res.data;
        this.projectsPortfolioInfo = ppi;
        this.extraData = ppi.extraData;
        let qseries = [];
        let qlabels = [];
        let qcolors = [];
        let qlegends = [];
        ppi.qualificationsData.forEach(f => {
          qseries.push(f.investment);
          qlabels.push(f.qualificationGroup);
          qcolors.push(this.qualificationColor(f.qualificationGroup));
          // qlegends.push({ k: f.qualificationGroup, v: this.explicitMoneyFormat(f.investment), p: this.prcgFormat(f.percent) });
          qlegends.push({ k: f.qualificationGroup, p: this.prcgFormat(f.percent, 2) });
        });
        this.qualificationsSeries = qseries;
        this.qualificationsChartOptions = { labels: qlabels, colors: qcolors };
        this.qualificationsLegendData = qlegends;
        if (!qseries.length) {
          this.ignoreQualificationsDonut = true;
        }

        let cseries = [];
        let clabels = [];
        let colors = [];
        let clegends = [];
        this.currentFixedInvestmentProjects = ppi.creditsData;
        this.currentFixedInvestmentProjects.forEach(f => {
          cseries.push(f.investment);
          const cn = this.explicitAssetCreditStatusName(f.asset_status, f.credit);
          const order = this.creditStatusOrder(f.asset_status, f.credit);
          clabels.push(cn);
          colors.push(this.creditStatusColor(f.asset_status, f.credit));
          // clegends.push({ k: cn, v: this.explicitMoneyFormat(f.investment), p: this.prcgFormat(f.percent), order: order });
          clegends.push({ k: cn, p: this.prcgFormat(f.percent, 2), order: order });
        });

        clegends.sort(function (a, b) {
          return a.order - b.order;
        });

        this.creditStatusesSeries = cseries;
        this.cstatusesChartOptions = { labels: clabels, colors: colors };
        this.creditStatusesLegendData = clegends;
        if (!cseries.length) {
          this.ignoreSunflowersDonut = true;
        }
      }
      catch (e) {

      }
    },
    async downloadCSV() {
      try {
        let filter;
        let startYear;
        let startMonth;
        let endYear;
        let endMonth;
        const date = new Date(this.lastMonthPortfolio.balance_date);
        filter = 'period';
        startYear = date.getFullYear();
        startMonth = date.getMonth();
        endYear = date.getFullYear();
        endMonth = date.getMonth();
        let params = `filter=${filter}&startYear=${startYear}&startMonth=${startMonth}&endYear=${endYear}&endMonth=${endMonth}`;
        let url = `${this.ApiDomain}/api/v2/investor/${this.InvestorId}/getPortfolioCSV?access_token=${this.AccessToken}&${params}`;
        window.open(url, "_blank");

        // se genera log de accion
        this.saveInvestorLogAction("LC9-17");
      }
      catch (e) {
        this.warn(e)
      }
    },
  }
}
</script>

<style lang="css" scoped>
.options-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.legend-list {
  display: inline-grid;
}
</style>
